<script setup>
import {onMounted, reactive, ref} from 'vue'

const props = defineProps({
    allProducts: Object,
    featuredProducts: Object
})

const filteredProducts = reactive({})

onMounted(() => {
    filterProducts()
})

function filterProducts() {
    for ( const prop in props.featuredProducts ) {
        for ( const product in props.allProducts ) {
            if ( props.featuredProducts[prop].product.slug === props.allProducts[product].slug ) {
                let filteredProduct = props.allProducts[product]

                filteredProduct.product_image = props.featuredProducts[prop].product_image

                filteredProducts[prop] = filteredProduct
            }
        }
    }
    console.log(filteredProducts)
}

</script>

<template>
    <div class="bg-cintra-grey dark overflow-hidden">
        <section v-for="( product, index ) in filteredProducts" :key="index">
            <a class="relative -top-32 invisible" :id="`product-${product.title.replace(/ /g, '-').toLowerCase()}`"></a>
            <div class="block-inner grid md:grid-cols-2 gap-14 py-14">
                <div class="flex flex-col justify-center"
                     :class="{
                         'lg:pl-20' : index % 2 === 0,
                         'lg:pr-20' : index % 2 !== 0
                     }">
                    <div class="py-14"
                         :class="{
                             'border-b border-b-white' : product.title == 'Assess'
                         }">
                        <h3>{{ product.title }}</h3>
                        <div class="font-light text-white" v-html="product.description" />
                        <a class="gradient-button mt-14" :href="product.permalink">
                            <span class="text-xl" :aria-label='`learn more about the "${product.title}" product`'>Learn more</span>
                        </a>
                    </div>
                    <div v-if="product.title == 'Assess'" >
                        <div v-if="product.children" class="links grid lg:grid-cols-2 gap-y-4 lg:gap-x-14 py-14">

                            <div v-for="service in product.children" class="text-cintra-grey flex flex-col justify-between">
                                <div>
                                    <h6 class="my-0">{{ service.title }}</h6>
                                    <p class="font-light my-1 md:my-2">{{ service.description }}</p>
                                </div>
                                <div>
                                    <a class="arrow-button" :aria-label='`learn more about the "${service.title}" service`' :href="service.permalink">Learn more</a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="hidden md:flex md:items-center md:justify-center"
                     :class="{ 'order-first' : index % 2 !== 0 }">
                    <div class="relative h-full w-full">
                        <img v-if="product.product_image"
                         class="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 h-full w-auto object-contain"
                         :src="product.product_image.permalink">
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style scoped>

</style>
